<template>
	<div @click.stop class="cart-box" v-if='showCart' :class="{load:showLoading}">
		<div class='load' v-show='showLoading'>
			<loading />
		</div>
		<template v-if='!showLoading'>
			<template v-if='cartProduct&&cartProduct.list[0]'>
				<p class="title">最近加入的購物車(Recently Added)<br><b @click="cleanCart">清空購物車(Clear Cart)</b></p>
				<div class="products" style="clear: both;">
					<div class="product" v-for="(item,index) in cartProduct.list">
						<img @click='select("/order/product/detail?sku="+item.sku)' class="img" src="@/assets/order/errorImg2.png" v-real-img="item.image_path_big">
						<div @click='select("/order/product/detail?sku="+item.sku)' class="center">
							<p class="name">{{item.name}}</p>
							<p class="pt">PV點數(PV Value)：{{item.pv}}<br>規格(Specifications)：{{item.specification}}</p>
						</div>
						<div class="right">
							<buyCart v-model="item.num" :product="item" :islrp='false' class='fk-cart-add1' :iscart='0' :lrpedit='false'  @showPromoCode='showPromoCode' @showTips='showTips' />
							<!-- <div class="stepper">
								<div class="button-primary sub"><Icon type="md-remove" /></div>
								<Input :value='item.num' style='width: 40px;' size='small'></Input>
								<div class="button-primary add"><Icon type="md-add" /></div>
							</div> -->
							<p class="price">HK${{item.price.toFixed(2)}}</p>
							<p class="remove" @click="deleteProduct(item)"><span>刪除(Delete)</span></p>
						</div>
					</div>
				</div>
				<div class="bottom">
					<div class="left">
						<p class="">共{{productCount}}件商品({{productCount}} sets in total)<br>共計(Total)<strong>HK${{detailPrice}}</strong></p>
						<p>總點數(Total PV Value)&nbsp;<strong>{{detailPv}}</strong></p>
					</div>

					<div @click.stop="saveCart" class="button-primary btn"><span>去結算(Process Order)</span></div>
				</div>
			</template>
			<div v-else class="notCart">
				<p>
					暫無商品(No sets)
					<p>
						<div @click.stop="nowOrder" class="button-primary btn1"><span>去購物(Go Shopping)</span></div>
			</div>

		</template>
	</div>
	
</template>

<script>
import loading from "@/components/order/loading";
import buyCart from "@/components/order/buyCart";
import { api_methods } from "@/service/loadData";
import {
	systemConfigMethods,
	cartInfoMethods,
	userInfoOrderMethods,
	promoCodeMethods
} from "@/components/common/mixin";
import { ssoUrl,baseUrl } from '@/config/env'
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
export default {
	data() {
		return {
			loadNumber: 0,
			showLoading: true,
			showData: false,
			confirmload: false,
			cartProduct: {
				totalPrice: 0,
				totalPv: 0,
				load: true,
				list: []
			}, //購物車商品列錶
		};
	},
	props: {
		showCart: {
			type: Boolean,
			default: false
		}
	},
	created() {
		this.$nextTick(function() {
			//this.initData()
		});
	},
	mounted() {},
	watch: {
		showCart: function(value) {

			// var hideCart=((this.$route.meta||{}).hideCart)
			// if(hideCart){
			// 	this.showCart=false;
			// 	return
			// }

			console.log(value,this.loadNumber)
			if (value && this.loadNumber == 0) {
				//加載數據
				console.log("加載數據");
				this.initData();
				this.loadNumber++;
			} else if (value) {
				this.initCategoryNum();
			}
		},
		shopCart: function(value) {
			if (value) {
				this.initCategoryNum();
			}
		},
		payPv: function(value, ovalue) {
			if (this.$route.path == "/order/confirm") {
				return;
			}
			// if (this.getUserId) {
			// 	if (this.isOriginalPrice && this.selfCarNo) {
			// 		if (!this.isPVOriginalPrice && ovalue < 100) {
			// 			//this.initCategoryNum();
			// 			this.showTips("恭喜您滿足100點數,享受優惠價格", 3000);
			// 		} else if (ovalue >= 100 && this.isPVOriginalPrice) {
			// 			//this.initCategoryNum();
			// 			this.showTips(
			// 				"非常抱歉點數不足100,無法享受優惠價格",
			// 				3000
			// 			);
			// 		} else if (ovalue < 100) {
			// 			this.showTips(
			// 				"如再購買" +
			// 					(100 - value).toFixed(2) +
			// 					"點,可以享受優惠價格",
			// 				4000
			// 			);
			// 		}
			// 	} else if (this.newcustomer) {
			// 		if (value > 0 && value < 50) {
			// 			this.showTips(
			// 				"如再購買" +
			// 					(50 - value).toFixed(2) +
			// 					"點,單筆訂單滿50點,即可獲得LRP回饋點數",
			// 				4000
			// 			);
			// 		}
			// 	}
			// }
		}
		// payPv: function(value, ovalue) {
		// 	if(this.$route.path=='/order/confirm'){
		// 		return
		// 	}
		// 	if (this.getUserId) {
		// 		if (this.isOriginalPrice) {
		// 			if ((100 - value)>0) {
		// 				this.showTips(
		// 					"如再購買" +
		// 						(100 - value).toFixed(2) +
		// 						"點,可以升級成為優惠顧客",
		// 					4000
		// 				);
		// 			}
		// 		} else if (this.newcustomer) {
		// 			if (value > 0 && value < 50) {
		// 				this.showTips(
		// 					"如再購買" +
		// 						(50 - value).toFixed(2) +
		// 						"點,單筆訂單滿50點,即可獲得LRP回饋點數",
		// 					4000
		// 				);
		// 			}
		// 		}
		// 	}
		// }
	},
	mixins: [systemConfigMethods, userInfoOrderMethods, cartInfoMethods,promoCodeMethods],
	components: {
		loading,
		buyCart
	},
	computed: {
		...mapGetters([
			"getVipNo",
			"getUserId",
			"bogo_switch_tip",
			"getAccessToken"
		]),
		...mapState({
			userInfo: state => state.common.wechatUserInfo,
			forCustomer: state => state.order.forCustomer,
			productInfo: state => state.order.productInfo,
			productStockInfo: state => state.order.productStockInfo,
			cartInfo: state => state.order.cartInfo,
			newpromoCode: state => state.order.newpromoCode,
			warehouseInfo: state => state.order.warehouseInfo,
			orderType: state => state.order.orderType,
			sysConfig: state => state.common.sysConfig
		}),
		warehouseList: function() {
			return [...((this.warehouseInfo || {}).value || {})];
		},
		productCount: function() {
			let num = 0;
			if (this.cartProduct && this.cartProduct.list) {
				this.cartProduct.list.forEach(item => {
					num += item.num;
				});
			}
			return num;
		},
		detailPrice: function() {
			if (this.cartProduct) {
				return this.cartProduct.totalPrice;
			}
			return 0;
		},
		detailPv: function() {
			if (this.cartProduct) {
				return this.cartProduct.totalPv;
			}
			return 0;
		},
		productStock: function() {
			let ret = [...((this.productStockInfo || {}).value || {})];
			return ret;
		},
		menuList: function() {
			let catalog = this.newcustomer;
			if (this.productInfo != null && this.productInfo.value != null) {
				var newProductInfo = [];
				var copyProducts;
				var notHot;
				if (!catalog) {
					copyProducts = JSON.parse(JSON.stringify(this.productInfo));
					notHot = copyProducts.value.filter(
						u =>
							u.name_en != "Hot" &&
							u.name_en != "LRPT2" &&
							u.name_en != "LRPT1"
					);
					if (notHot[0]) {
						copyProducts.value = notHot;
					}
				} else {
					copyProducts = JSON.parse(JSON.stringify(this.productInfo));
					notHot = copyProducts;
					if (notHot[0]) {
						copyProducts.value = notHot;
					}
				}
				copyProducts.value.forEach((item, i1, lists) => {
					var result = true;
					item.id = this.isEmpty(item.id) ? "0" : item.id;
					item.products.forEach((product, i2, productList) => {
						let sku = product.sku;
						if (!catalog) {
							if (product.is_lrpt_product != 0) return;
						} else {
							//if(product.promo_flag==1||product.promo_flag==2) return;
						}
						let is_inventory = product.is_inventory;
						if (
							is_inventory == 1 ||
							(is_inventory == 10 &&
								this.default_store_id == "501")
						) {
							//庫存商品才校驗庫存
							//let stock = product.stock;
							//"warehouse":"501",
							//let control = this.productStock.control;      //0:無庫存，不能看到，1:無庫存，不能銷售，但能看到
							product.control = -1; //未查詢到庫存信息
							product.stock = 0;
							this.productStock.forEach((warehouse, index1) => {
								if (
									this.default_store_id == warehouse.warehouse
								) {
									warehouse.stock.forEach((stock, index2) => {
										let control = stock.control;
										if (stock.sku == sku) {
											//result = true;
											if (stock.stock <= 0) {
												product.control = control;
											} else {
												product.control = 2; //有庫存，可以銷售
											}
											product.stock = stock.stock;
										}
									});
								}
							});
						} else if (is_inventory == 10) {
							product.control = -1;
						} else {
							product.control = 10; //不判斷庫存，任意銷售
							product.stock = 999999999;
						}
						productList[i2] = product;
					});
					if (result) {
						newProductInfo.push(item);
					}
					//lists[i1] = item;
				});
				return newProductInfo;
			} else {
				return [...((this.productInfo || {}).value || {})];
			}
			//return this.productInfo.value;
		}
	},
	methods: {
		...mapActions([
			"initProductStock",
			"initProductAction",
			"initProductLimtAction",
			"saveStoreIdAction",
			"saveCartAction",
			"initWarehouseAction",
			"initCartAction",
			"clearCart",
			"updateCartAction"
		]),
		...mapMutations([
			"EDIT_CART1",
			"REDUCEALL_LRP",
			"REDUCE_NEWPROMOCODE",
			"SET_CART_TOTALRPT",
			"SET_ORDERTYPE",
			"CLEAR_CART"
		]),
		async initData() {
			var meta = this.$route.meta || {};
			if (!meta.NotLoadData) {
				await this.initWarehouseAction();
				await this.initProductStock(this.default_store_id);
				await this.initProductAction();
				await this.initProductLimtAction();
			}
			//await this.initCartAction();
			this.initCategoryNum();
			this.setCartTotal(this.baseDeliveryFee, this.baseServiceFee, 0);
			this.showLoading = false;
		},
		setCartTotal(delivery_fee, service_fee, ar_value) {
			this.SET_CART_TOTALRPT({ delivery_fee, service_fee, ar_value });
		},
		async cleanCart() {
			this.$Modal.confirm({
				title: "提示(Tip):",
				content:
					"確定要清除購物車嗎?<br>You sure you want to clear the cart?",
				loading: true,
				okText: "確定(Confirm)",
				cancelText: "取消(Cancel)",
				onOk: async () => {
					if (this.getUserId) {
						let res = await api_methods.clearCart(
							this.getAccessToken,
							"",
							this.userInfo.value.binding.user_id
						);
						if (res && res.response && res.response.code == "1") {
							this.CLEAR_CART();
							this.$Modal.remove();
						} else {
							this.$Modal.error({
								title: "錯誤 (error)",
								content: res
							});
						}
					} else {
						this.CLEAR_CART();
						this.$Modal.remove();
					}
				}
			});
		},
		async saveCart() {
			// if(this.confirmload){
			//     return
			// }

			if (!this.getUserId) {
				// this.$Modal.info({
				//     title:'提示 (Tips)',
				//     content:'請登陸',
				//  })
				// this.$emit("showCustomer");
				let redirect;
				if (process.env.NODE_ENV === 'development') {
					redirect = escape(`http://localhost:9000/#/home`);
				} else {
					redirect = escape(`${baseUrl}/client/index.html#/home`);
				}
				location.href = `${ssoUrl}/sso/index.html#/hklogin?from=hk&redirect=${redirect}`;
				return;
			}
			this.confirmload = true;
			let ret = await this.saveStoreIdAction(this.default_store);
			if (ret) {
				this.$Modal.error({
					title: "錯誤 (error)",
					content: ret
				});
				this.confirmload = false;
				return false;
			}

			this.setCartTotal(this.baseDeliveryFee, this.baseServiceFee, 0);
			let ll = this.shopCartList();
			let cv = this.cartInfo.value;
			let minCart = {
				id: cv.id,
				customer_id: this.userInfo.value.binding.user_id,
				store_id: this.default_store_id,
				address_id: 0,
				total_num: cv.num,
				total_price: cv.total_price,
				total_pv: cv.total_pv,
				total_change_point: cv.total_change_point,
				total_change_point_num: cv.total_change_point_num,
				total_product_amount: cv.total_product_amount,
				delivery_fee: cv.delivery_fee,
				service_fee: cv.service_fee,
				ar_value: cv.ar_value,
				pay_fee: cv.pay_fee,
				spec_code: null,
				detail: ll
			};
			ret = await this.saveCartAction({ minCart, type: false });
			this.confirmload = false;
			if (ret && ret.response && ret.response.code == "1") {
				if (ret.data.value.code == 1) {
					if (this.newcustomer) this.SET_ORDERTYPE(11);
					else this.SET_ORDERTYPE(0);

					this.$router.push("/order/cart");
				} else if (ret.response.errorCode == "0100") {
					//這裏改為全局處理
				} else {
					this.$Modal.error({
						title: "錯誤 (error)",
						content: ret.data.value.message
					});
				}
			} else {
				this.$Modal.error({
					title: "錯誤 (error)",
					content: "保存購物車失敗"
				});
			}
		},
		nowOrder() {
			this.$router.push("/order/product");
		},
		showTips(msg, s) {
			this.$Toast.show(msg, { duration: s });
		},
		shopCartList() {
			let newArr = new Array();
			this.shopCart.forEach(item => {
				if (item.num > 0) {
					var product_flag = item.is_lrpt_product || 0;
					if (item.is_hot == "1" && this.orderType != 0) {
						product_flag = 100;
					}
					var remark=null
					if(item.promo_code!=''&&item.promo_code){
						remark=this.getBySkuJson(item.sku)
					}

					newArr.push({
						attrs: [],
						extra: {},
						id: item.id,
						name: item.name,
						packing_fee: item.packing_fee,
						price: item.price,
						pt: item.pt,
						pv: item.pv,
						point: item.point,
						amount: item.amount, //現金支付金額
						ar_value: 0, //AR支付金額
						num: item.num, //數量(個數)，point支付和 amount支付總計個數
						sku_id: item.sku_id,
						sku: item.sku,
						specs: item.specs,
						stock: item.stock,
						selected: item.selected,
						spec_code: null,
						product_flag: product_flag,
						promo_code: item.promo_code,
						Url: null,
						remark:remark
					});
				}
			});
			return newArr;
		},
		deleteProduct(product) {
			let sku = product.sku;
			//var pn=product.num;
			let num = 0;
			let edit_cart = this.EDIT_CART1;
			edit_cart({ sku, num });
			// this.IsPromoteTip(sku,0)
			var item = this.getLRPType(20);
			if (item[0] && this.lrpProductLimit < 125) {
				this.showTips(
					"小dō溫馨提示:由於您的單筆訂單未滿125點，清暢三部麯LRP套裝將被移除",
					3000
				);
				this.REDUCEALL_LRP(item[0]);
			}
			//檢測大會代碼是否刪除 如果刪除 將刪除狀態
			var newcode = this.newpromoCode[sku];
			if (newcode) {
				this.REDUCE_NEWPROMOCODE(sku);
			}
			this.updateCart(sku, num);
		},
		updateCart(sku, num) {
			var params = {
				//customerId:this.getUserId,
				sku,
				num
			};
			this.updateCartAction(params);
		},
		initCategoryNum() {
			var cartProductNum = 0;
			var totalPrice = 0;
			var totalPv = 0;
			var cartProductList = [];
			let productSku = {};
			let sc = this.shopCart;
			let op = this.isPVOriginalPrice;
			this.menuList.forEach((item, index) => {
				if (item.products && item.products[0]) {
					item.products.forEach(products => {
						let productItem = sc.filter(
							u => u.sku == products.sku && u.num > 0
						)[0];
						if (productItem) {
							if (!productSku[products.sku]) {
								let productPrice =
									products.specproducts[0] || {};
								var Price = op
									? productPrice.original_price
									: productPrice.price;
								totalPrice += productItem.num * Price;
								totalPv += productItem.num * productItem.pv;
								cartProductList[cartProductNum] = {};
								cartProductList[cartProductNum] = products;
								cartProductList[cartProductNum].num =
									productItem.num;
								cartProductList[cartProductNum].price = Price;
								cartProductList[cartProductNum].pv =
									productPrice.pv;
								cartProductList[cartProductNum].specification =
									products.specification;
								productSku[products.sku] = 1;
								cartProductNum++;
							}
						}
					});
				}
			});
			this.cartProduct.list = [];
			this.cartProduct.list = cartProductList;
			this.cartProduct.totalPrice = totalPrice.toFixed(2);
			this.cartProduct.totalPv = totalPv.toFixed(2);
			this.cartProduct.load = false;
		},
		select(string) {
			this.$router.push(string);
		},
		showPromoCode(products,type) {
			if (products) {
				this.$emit("showPromoCode", products,type);
			}
		},
	
	}
};
</script>

<style lang='scss' scoped>
@import "@/style/mixin";
@import "@/style/common";
.load {
	height: 300px;
	position: relative;
}
.notCart {
	padding: 30px;
	text-align: center;
	p {
		font-size: 18px;
		font-weight: bold;
		padding-bottom: 10px;
	}
}
.cart-box {
	text-align: left;
	position: absolute;
	box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.2);
	top: 0.82rem;
	left: 54.53vw;
	width: 30.85vw;
	min-width: 400px;
	z-index: 999;
	background-color: white;
	&.load {
		width: 23.44vw;
		left: -15.13vw;
	}
	.title {
		padding: 20px;
		padding-bottom: 0;
		b {
			float: right;
			// padding-right: 1.04vw;
			color: $theme-color;
			font-weight: 500;
		}
	}
	.products {
		// max-height: 540px;
		max-height: 70vh;
		// overflow-y: scroll;
		padding: 20px;
		padding-top: 0;
	}
	.product {
		display: flex;
		// justify-content: center;
		align-items: center;
		padding: 1.56vw 0;
		// border-bottom: 1px solid #eee;
		.img {
			width: 7.81vw;
		}
		.center {
			// flex: 1;
			padding-left: 1.04vw;
			.pt {
				margin-top: 1.04vw;
			}
		}
		.right {
			text-align: center;
			display: flex;
			flex-direction: column;
			.stepper {
				display: flex;
				.sub,
				.add {
					background-color: $theme-color;
					color: white;
					width: 24px;
					text-align: center;
					margin: 0 5px;
					border-radius: 5px;
				}
			}
			.price {
				margin-top: 10px;
			}
			.remove {
				cursor: pointer;
				margin-top: 20px;
				span:hover {
					color: $theme-color;
					text-decoration: underline;
				}
			}
		}
	}
	.bottom {
		padding: 0 20px;
		background-color: #f4f5f6;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
}
.btn {
	// width: 8.33vw;
	font-size: 15px;
	color: white;
	background-color: $theme-color;
	border-radius: 40px;
	text-align: center;
	// height: 2.08vw;
	line-height: 1.1;
	font-weight: bold;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 10px 0;
	padding: 10px;
}
.btn1 {
	font-size: 18px;
	color: white;
	background-color: $theme-color;
	border-radius: 40px;
	text-align: center;
	height: 2.13vw;
	font-weight: bold;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 10px 0;
}
</style>